var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutStyle,{tag:"component",attrs:{"bg-img":_vm.newsDetail.imgUrl}},[_c(_vm.mainStyle,{tag:"component",attrs:{"data":_vm.newsDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }